// extracted by mini-css-extract-plugin
export default {"container":"mUwJ5E","logo":"l2_pzm","nowrap":"C8uVox","modalTrigger":"gmCKIe","extraSpace":"Gs0a6g"};